import { useEffect, useState } from "react";
import TemplateFull from "../../../../components/TemplateFull/TemplateFull";
import CtaWrapper from "../../../../components/CtaWrapper/CtaWrapper";
import Button from "../../../../components/Button/Button";
import LoaderPanel from "../../../../components/LoaderPanel/LoaderPanel";

import styles from "./index.module.scss";
import imageBorsa from '../../../../assets/images/premio-borsa.png';
import imageMagliettaRossa from '../../../../assets/images/premio-tshirt-red.png';
import imageMagliettaBianca from '../../../../assets/images/premio-tshirt-white.png';
import imageFelpa from '../../../../assets/images/premio-felpa-red.png';

const DOOR_IMAGE_URL = "https://www.mcdonalds.it/sites/default/files/html/2026-02/friends--door-v1.png";

const PRIZE_IMAGE_URL = (prize: string) => {
  switch (prize) {
    
    case "Borsa":
      return imageBorsa;
    case "Maglietta Rossa S/M":
    case "Maglietta Rossa L/XL":

      return imageMagliettaRossa;
    case "Maglietta Bianca S/M":
    case "Maglietta Bianca L/XL":
      return imageMagliettaBianca;
    case "Felpa S/M":
    case "Felpa L/XL":
      return imageFelpa;
  }
  return "";
}

interface TemplateInstantWinProps {
  won: boolean;
  prize: string;
  onBackToResults: (() => void) | null;
}

const TemplateInstantWin: React.FC<TemplateInstantWinProps> = ({ won, prize, onBackToResults }) => {
  
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        setIsLoading(false);
        setTimeout(() => {
          setIsOpen(true);
        }, 500);
      }, 500);
    }
  }, [isLoading]);

  return (
    <TemplateFull>
      <LoaderPanel active={isLoading} />
      <div className={`${styles.ZoomPanel} ${isOpen ? styles.open : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <div className={styles.door}>
          <div className={styles.handle}></div>
          <img src={DOOR_IMAGE_URL} alt="Door" />
        </div>
      </div>
      <div className={styles.Prize}>
        <div className={styles.PrizeContent}>
          <hgroup>
            <h2>{won ? 'Complimenti!' : 'Ci dispiace'}</h2>
            {won ? (
              <>
                <h1 className={styles.WonH1}>Hai vinto!</h1>
                <h2 className={styles.PrizeTitle}>{prize.toUpperCase()}</h2>
              </>
            ) : (
              <h1>Non hai vinto!</h1>
            )}
            { !won && (
              <h3>Ritenta con<br />il prossimo Quiz!</h3>
            )}
          </hgroup>
          { won && (
            <>
              <img src={PRIZE_IMAGE_URL(prize)} alt="Prize" />
              <p>A fine iniziativa riceverai una email all'indirizzo utilizzato in fase di registrazione in App per compilare i tuoi dati di spedizione.</p>
            </>
          )}
        </div>
        { onBackToResults && (
          <CtaWrapper>
            <Button onClick={onBackToResults}>
              Scopri le prossime date
            </Button>
          </CtaWrapper>
        )}
      </div>
    </TemplateFull>
  );
}

export default TemplateInstantWin;